"use client"

import { useEffect } from "react"
import { track, Events } from "@/lib/analytics"

/**
 * Fires LANDING_VIEWED once per mount.
 * No-op until consent is given (handled inside track()).
 */
export function LandingViewTracker() {
  useEffect(() => {
    track(Events.LANDING_VIEWED)
  }, [])
  return null
}
